interface Props {
  className?: string;
  style?: React.CSSProperties;
}

export const FolderIcon = ({ className, style }: Props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M21 6H14.5003L11.8997 4.05C11.6397 3.85599 11.3241 3.7508 10.9997 3.75H6.75C6.35218 3.75 5.97064 3.90804 5.68934 4.18934C5.40804 4.47064 5.25 4.85218 5.25 5.25V6.75H3.75C3.35218 6.75 2.97064 6.90804 2.68934 7.18934C2.40804 7.47064 2.25 7.85218 2.25 8.25V18.75C2.25 19.1478 2.40804 19.5294 2.68934 19.8107C2.97064 20.092 3.35218 20.25 3.75 20.25H18.0834C18.459 20.2495 18.819 20.1001 19.0846 19.8346C19.3501 19.569 19.4995 19.209 19.5 18.8334V17.25H21.0834C21.459 17.2495 21.819 17.1001 22.0846 16.8346C22.3501 16.569 22.4995 16.209 22.5 15.8334V7.5C22.5 7.10218 22.342 6.72064 22.0607 6.43934C21.7794 6.15804 21.3978 6 21 6ZM18 18.75H3.75V8.25H7.99969L10.8 10.35C10.9298 10.4474 11.0877 10.5 11.25 10.5H18V18.75ZM21 15.75H19.5V10.5C19.5 10.1022 19.342 9.72064 19.0607 9.43934C18.7794 9.15804 18.3978 9 18 9H11.5003L8.89969 7.05C8.63967 6.85599 8.32411 6.7508 7.99969 6.75H6.75V5.25H10.9997L13.8 7.35C13.9298 7.44737 14.0877 7.5 14.25 7.5H21V15.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
